import React from 'react';
import ReactDOM from 'react-dom';
import { ReactQueryDevtools } from 'react-query/devtools';

import { userAgentUtils } from 'utils/UserAgentUtils';

import EnvSetting from 'components/env-setting/EnvSetting';

import './dev-tools.scss';

const DevTools = () => {
  const platform = userAgentUtils();
  const isMobileBrowser =
    platform === 'iOS' || platform === 'Android' || platform === 'unknown';

  return (
    <div
      className="dev-tools-container pointer fixed z-[99] flex items-center rounded-[4px] border border-solid border-n-600 bg-n-200 p-[8px] shadow-raised"
      style={{
        left: '-100px',
        bottom: '-50px'
      }}
    >
      <ReactQueryDevtools
        initialIsOpen={false}
        toggleButtonProps={{
          style: { position: 'static', margin: '0px', padding: '0px' }
        }}
      />
      {!isMobileBrowser && <EnvSetting />}
    </div>
  );
};

const DevToolsPortal = () => {
  const devtoolsContainer = document.getElementById('devtools-container');

  return ReactDOM.createPortal(<DevTools />, devtoolsContainer);
};

export default DevToolsPortal;
